import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import type { ManagedFleet } from '../..';

interface PlatformAccountSourceIdCellProps {
  rowData: ManagedFleet;
}

export default function PlatformAccountSourceIdCell({
  rowData: { sourceId },
}: PlatformAccountSourceIdCellProps) {
  const { searchString } = useSearchContext();
  return <HighlightText text={sourceId} searchText={searchString} />;
}
